
  import { defineComponent, computed } from 'vue';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';

  export default defineComponent({
    name: 'kt-user-menu',
    components: {},
    setup() {
      const router = useRouter();
      const i18n = useI18n();
      const store = useStore();

      // direction and stylesheet must move together with the locale, both on
      // boot and on every switch, or the page keeps the previous direction
      const applyDirection = (lang: string) => {
        const html = document.documentElement;
        const isRtl = lang === 'ar';
        const appStyle = document.getElementById(
          'appStyle'
        ) as HTMLLinkElement | null;

        html.setAttribute('lang', lang);

        if (isRtl) {
          html.setAttribute('dir', 'rtl');
          html.setAttribute('direction', 'rtl');
        } else {
          html.removeAttribute('dir');
          html.removeAttribute('direction');
        }
        html.style.direction = isRtl ? 'rtl' : '';

        if (appStyle) {
          appStyle.href = isRtl ? '/css/style.rtl.css' : '/css/style.css';
        }
      };

      i18n.locale.value = localStorage.getItem('lang')
        ? (localStorage.getItem('lang') as string)
        : 'en';

      applyDirection(i18n.locale.value);

      const countries = {
        en: {
          flag: '/media/flags/united-states.svg',
          name: 'English',
        },
        ar: {
          flag: '/media/flags/kuwait.svg',
          name: 'العربية',
        },
      };

      const signOut = () => {
        const userType = window.localStorage.getItem('loginType');
        store.dispatch(Actions.LOGOUT, 1).then(() => {
          if (userType === 'appraisers') router.push('/sign-in-appraiser');
          else if (userType == 'bank') router.push('/sign-in-banks');
          else router.push({ name: 'sign-in' });
        });
      };

      const setLang = (lang) => {
        localStorage.setItem('lang', lang);
        i18n.locale.value = lang;
        applyDirection(lang);
      };

      const currentLanguage = (lang) => {
        return i18n.locale.value === lang;
      };

      const currentLangugeLocale = computed(() => {
        return countries[i18n.locale.value];
      });
      const user = store.getters.currentUser;
      const profilePageRoute = computed(() => {
        if (user.userType === 'appraisers')
          return { name: 'appraisers-editing', params: { id: user.id } };
        else if (user.userType === 'banks')
          return { name: 'banks-editing', params: { id: user.id } };
        return { name: 'admins-editing', params: { id: user.id } };
      });

      return {
        user,
        signOut,
        setLang,
        currentLanguage,
        currentLangugeLocale,
        countries,
        profilePageRoute,
      };
    },
  });
